import theme from '../../services/theme'

export default {
    searchIcon: theme.components.Textinput.Search.icon,
    resetIcon: theme.components.Textinput.Search.resetIcon,
    variants: theme.components.Textinput.variants,
    requiredColor: theme.palette.error.main
}